import { AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReplaySubject, Subject } from 'rxjs';
import { ReportUser } from 'src/app/models/user';
import { FreeFormMinutesService } from 'src/app/service/free-form-minutes.service';
import { ReportService } from 'src/app/service/report.service';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { AttendeeService } from 'src/app/service/attendee.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MeetingService } from 'src/app/service/meeting.service';

declare var CKEDITOR: any;

@Component({
  selector: 'app-send-message-dialog',
  templateUrl: './send-message-dialog.component.html',
  styleUrls: ['./send-message-dialog.component.css']
})
export class SendMessageDialogComponent implements OnInit {
  data: any;
  particToggler = true;
  toppingsControl = new UntypedFormControl([Validators.required]);
  ckEditorConfig: any;
  subject: any;
  message: any;
  public users!: any[];
  public email: any[] = [];
  newPresenterList: any = [];

  public userServerSideFilteringCtrl: UntypedFormControl = new UntypedFormControl();
  public searching: boolean = false;

  public filteredServerSideUsers: ReplaySubject<ReportUser[]> = new ReplaySubject<ReportUser[]>(1);

  protected _onDestroy = new Subject<void>();


  @ViewChild("agSendckeditor", { static: false }) SendCk: any;

  constructor(private spinner: NgxSpinnerService, private attendeeService: AttendeeService, @Inject(MAT_DIALOG_DATA) data: any, private reportService: ReportService, public commonMinService: FreeFormMinutesService, private sideNav: SideNavServiceService,private meetingService:MeetingService) {
    this.ckEditorConfig = {
      removePlugins: 'floatingspace,elementspath,magicline,wsc,scayt,liststyle,contextmenu,tableselection,tabletools,tableresize',
      //toolbar: [{ name: 'basicstyles', groups: ['basicstyles'], items: ['Bold', 'Italic', 'Underline', 'Strike'] },//, 'Subscript', 'Superscript'] },
      toolbar: [{ name: 'basicstyles', groups: ['basicstyles'], items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript'] },
      { name: 'paragraph', groups: ['list'], items: ['NumberedList', 'BulletedList'] },
      { name: 'insert', items: ['Table'] }
        //{ name: 'paragraph', groups: ['list'], items: ['NumberedList', 'BulletedList'] },
        //{ name: 'insert', items: [ 'Image'] },
        //    , { name: 'insert', items: ['Image'] }
      ],
      //disableNativeSpellChecker : false
      //commented for image insertion
      //imageUploadUrl: 'uploadImageAsNote.action',
      //uploadUrl: 'uploadImageAsNote.action'
    };
    this.toppingsControl.setValue(null);
    this.data = data;
    this.meetingService.getDefaultMessage().subscribe((data:any) => {
      this.subject = data.subject;
      this.SendCk.data = data.content;
    })
  }


  ngOnInit(): void {

  }



  loadPresenter(obj: any, id: any) {
    var assignedTo: any;
    var user = this.data.meetingResp.attendeeList;
    var addUser = this.newPresenterList
    return new Promise((resolve, reject) => {
      this.attendeeService.loadAttendeeAgendaPresenters('true', 'ATTs', obj, user, addUser)
        .then(($inputor: any) => {
          var pageIns = this;
          $inputor.off("inserted.atwho");
          $inputor.on("inserted.atwho", function (event: any, $li: any, query: any) {
            if ($li.length != 0) {
              $('.atwho-inserted:first', obj);

              $('.atwho-inserted:first', obj).before("<span class='presentedByCls' contentEditable='false'>, </span>");
              assignedTo = {
                "fkSecUserAttendee": Number($li.data('item-data').id),
                "attendeeName": $li.data('item-data').value,
                "attendeeEmail": $li.data('item-data').email
              }
              resolve(assignedTo);
            }
          })
        })
    }).then((respVal: any) => {
      obj.value = "";
      this.newPresenterList.push(respVal);
      document.getElementById('messageUser')?.click();
    })
  }

  showAddParticipants() {
    this.particToggler = true
    this.toppingsControl.setValue('');
  }

  callTrigger() {
    this.toppingsControl.setValue(this.toppingsControl.value);
  }

  onToppingRemoved(topping: any, type: any) {
    if (type == 0) {
      const toppings = this.toppingsControl.value as string[];
      this.removeFirst(toppings, topping);
      this.callTrigger();
    }
    else {
      const additionalpart = this.newPresenterList;
      this.removeFirst(additionalpart, topping)
    }
  }

  private removeFirst<T>(array: T[], toRemove: T): void {
    const index = array.indexOf(toRemove);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }


  hideAddParticipants() {
    this.particToggler = false
    this.toppingsControl.setValue(this.data.meetingResp.attendeeList)
  }

  sendDraft() {
    this.spinner.show();
    if ((this.newPresenterList.length == 0) && (this.toppingsControl.value == undefined || this.toppingsControl.value == '' || this.toppingsControl.value == null)) {
      this.spinner.hide();
      this.sideNav.alertNotifyError("Please Choose Participant")
      return;
    }

    if (this.subject == "" || this.subject == null || this.subject == undefined) {
      this.spinner.hide();
      this.sideNav.alertNotifyError("Please fill Subject")
      return;
    }
    if (this.SendCk.data == "" || this.SendCk.data == null || this.SendCk.data == undefined) {
      this.spinner.hide();
      this.sideNav.alertNotifyError("Please fill Content")
      return;
    }
    var email: any[] = [];
    if (this.toppingsControl.value != null) {
      Array.prototype.push.apply(email, this.toppingsControl.value)
    }
    if (this.newPresenterList.length > 0) {
      Array.prototype.push.apply(email, this.newPresenterList)
    }


    var json = {
      attendeeList: email,
      subject: this.subject,
      content: this.SendCk.data,
      meetingTitle: this.data.meetingResp.meetingTitle,
      meetingDate: this.data.meetingResp.meetingDateFullFormat,
      meetingId: this.data.meetingResp.meetingId
    }
    this.meetingService.sendNotification(json).subscribe((data) => {
      if (data.body.message == "success")
        this.spinner.hide();
      this.sideNav.alertNotifySuccess("Message Sent Successfully");
    }, error => {
      this.spinner.hide();
      this.sideNav.alertNotifySuccess("Error : " + error);
    })
  }

  reset() {
    this.subject = "";
    this.SendCk.data = "";
  }

}
